import http from "@/api/http.js";

export function getCurrencies() {
  return http.get("/infoauto/currencies").then(res => {
    return res.data;
  });
}

export function getPaymentsTypes() {
  return http.get("/infoauto/payments_types").then(res => {
    return res.data;
  });
}

export function getSellers() {
  return http.get("/infoauto/sellers").then(res => {
    return res.data;
  });
}

export function getCargos() {
  return http.get("/infoauto/cargos").then(res => {
    return res.data;
  });
}

export function getCountries() {
  return http.get("/infoauto/countries").then(res => {
    return res.data;
  });
}

export function getStates(country) {
  return http.get(`/infoauto/states/${country}`).then(res => {
    return res.data;
  });
}

export function getCities(country, state) {
  return http.get(`/infoauto/cities/${country}/${state}`).then(res => {
    return res.data;
  });
}

export function getDepositos() {
  return http.get(`/infoauto/depositos`).then(res => {
    return res.data;
  });
}

export function getPriceGroups() {
  return http.get(`/infoauto/grupos_precios`).then(res => {
    return res.data;
  });
}

export function getSyncPriceGroups() {
  return http.get("/infoautosync/sync_grupos_precios").then(res => {
    return res.data;
  });
}

export function getSyncDepositos() {
  return http.get("/infoautosync/sync_depositos").then(res => {
    return res.data;
  });
}

export function getSyncCurrencies() {
  return http.get("/infoautosync/sync_currencies").then(res => {
    return res.data;
  });
}

export function getSyncSellers() {
  return http.get("/infoautosync/sync_sellers").then(res => {
    return res.data;
  });
}

export function getSyncCargos() {
  return http.get("/infoautosync/sync_cargos").then(res => {
    return res.data;
  });
}

export function getSyncCountries() {
  return http.get("/infoautosync/sync_countries").then(res => {
    return res.data;
  });
}

export function getSyncStates() {
  return http.get("/infoautosync/sync_states").then(res => {
    return res.data;
  });
}

export function getSyncCities() {
  return http.get("/infoautosync/sync_cities").then(res => {
    return res.data;
  });
}

export function searchPersonInfoauto(search) {
  return http.get(`/infoauto/search_person?search=${search}`).then(res => {
    return res.data;
  });
}

export function getPersonAdressList(personId) {
  return http.get(`/infoauto/person_address/${personId}`).then(res => {
    return res.data;
  });
}

export function getDepartamentos() {
  return http.get("/infoauto/departamentos").then(res => {
    return res.data;
  });
}

export function lookupCountries() {
  return http.get("/infoauto/lookup_countries").then(res => {
    return res.data;
  });
}

export function lookupStates(countryCode, stateName = null) {
  let url = `/infoauto/lookup_states/${encodeURIComponent(countryCode)}`;
  if (stateName) {
    url += `?state=${encodeURIComponent(stateName)}`;
  }
  return http.get(url).then(res => {
    return res.data;
  });
}

export function getSyncDepartamentos() {
  return http.get("/infoautosync/sync_departamentos").then(res => {
    return res.data;
  });
}
